<div class="d-flex align-items-center justify-content-start gap-2">
  <div class="d-flex align-items-center justify-content-center image-container">
    <img #img (error)="img.src='/assets/avatar_placeholder.png'"
      [src]="coverUrl != null ? coverUrl : '/assets/avatar_placeholder.png'">
  </div>
  <div class="d-flex flex-column">
    <span class="ellipsis" [ngClass]="bold ? 'bold small' : ''">{{name}}</span>
    <span class="small ellipsis">{{representative}}</span>
    <!-- Admin clinics list: scheduled account deletion (props.showDeletionBadge) -->
    <span *ngIf="deletionScheduledAt" class="badge bg-danger-subtle text-danger align-self-start mt-1">
      <i class="ti ti-trash me-1"></i>Will be deleted on {{ deletionScheduledAt | date: 'dd/MM/yyyy' }}
    </span>
  </div>
</div>